module.exports = __webpack_public_path__ + "static/media/modelD2.0ca9fff0.gif";